import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable } from '@angular/core';
import { LogService } from './log.service';
// declare var newrelic: any;
@Injectable({
  providedIn: 'root'
})
export class GlobalErrorHandlerService implements ErrorHandler {
  public Errors: Array<any> = [];
  constructor(public log: LogService) { }
  /* istanbul ignore next */
  handleError(error: Error) {
    this.log.error(error);
    // if (newrelic)
    //   newrelic.noticeError(error);
    // this.Errors.push(error.message);
    // localStorage.setItem('errors', JSON.stringify(this.Errors));
  }

}
